import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchCategory(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.SEARCH_PRODUCT, action.payload, true);
}

export function* addUpdateProduct(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.ADD_UPDATE_PRODUCT, action.payload, true);
}

export function* deleteProduct(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.DELETE_PRODUCT, action.payload, true);
}

export function* generateSKU(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.PRODUCTS.GENERATE_SKU, action.payload, true);
}

export function* updateInventory(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.UPDATE_INVENTORY, action.payload, true);
}

export function* updatePrices(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.UPDATE_PRICES, action.payload, true);
}

export function* bulkUpdateProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.BULK_UPDATE_PRODUCTS, action.payload, true);
}

export function* changeProductStatus(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.STATUS_CHANGE, action.payload, true);
}

export function* nonTaxableProductSearch(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.NON_TAXABLE_PRODUCT_SEARCH, action.payload, true);
}

export function* addNonTaxableProduct(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.ADD_NON_TAXABLE_PRODUCT, action.payload, true);
}

export function* checkSKUUnique(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.PRODUCTS.CHECK_SKU_UNIQUE, action.payload, true);
}

export function* rearrangeProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.REARRANGE_PRODUCTS, action.payload, true);
}

export function* adminPopularProductSearch(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.ADMIN_POPULAR_PRODUCT_SEARCH, action.payload, true);
}

export function* rearrangePopularProducts(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.PRODUCTS.REARRANGE_POPULAR_PRODUCTS, action.payload, true);
}
